import { useEffect } from "react";
import { Button, Checkbox } from "antd";
import { YhBox } from "@/components/YhBox";
import { useReleaseModel } from "../takeMealModel";
import { IFoodCategoryOotion } from "@/types/AppEnums";
import { getBaseImgLookUrl } from "@/utils/constants";
import { debounce } from "lodash";
export const MealBox = () => {

    const { initPgCfg,
        dayMeal,
        mealList,
        dayMealList,
        mealSearchParam,
        setMealSearchParam,
        loadLibrary,
        setDayMealList,
        insertMenu,
        updateMenu
    } = useReleaseModel();
    useEffect(() => {
        loadLibrary()
    }, [])
    const onMealType = (item: any, index: number) => {
        setMealSearchParam({ ...mealSearchParam, category: item.value })
        loadLibrary(initPgCfg, { ...mealSearchParam, category: item.value })
    }
    const onFood = (item: any, index: number) => {
        let findIndex = dayMealList.findIndex(i => i.foodId === item.id)
        let newDayMealList = [...dayMealList]
        if (findIndex === -1) {
            newDayMealList.push({
                foodId: item.id,
                cookId: ""
            })
            setDayMealList(newDayMealList)
        } else {
            newDayMealList.splice(findIndex, 1);
            setDayMealList(newDayMealList)
        }
    }
    const onRelease = () => {
        dayMeal?.foods ? updateMenu() : insertMenu()
    }
    return (
        <div className="right">
            <YhBox
                title={""}
                style={{
                    width: "286px",
                    height: "690px",
                    marginRight: "20px",
                }}
            >
                <div className="release">
                    <div className="meal">
                        {IFoodCategoryOotion.map((item, index) => (
                            <p key={index} className={`meal-type ${item.value === mealSearchParam.category ? 'meal-active' : ''}`} onClick={() => onMealType(item, index)}>{item.label}</p>
                        ))}
                    </div>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        // onClick={onRelease}
                        onClick={debounce(() => { onRelease() }, 900)}
                    >{dayMeal?.foods ? '菜品修改' : '菜品发布'}</Button>
                </div>
            </YhBox>
            <YhBox
                title={""}
                style={{
                    width: "555px",
                    height: "690px",
                    overflowY: "auto"
                }}
            >
                <div className="food">
                    {mealList.filter(fliterItem => dayMealList.map(item => item.foodId).indexOf(fliterItem.id as string) !== -1)
                        .map((item, index) => {
                            return (
                                <div key={index} className="food-item" onClick={() => onFood(item, index)}>
                                    <div className="img">
                                        <img className="img-detail" src={getBaseImgLookUrl(item.image as string)} alt={item.name} />
                                        <Checkbox className="img-check" checked={true} />
                                    </div>
                                    <div className="message">
                                        <span className="name">{item.name}</span>
                                        <p className="other">
                                            <span>口感：{item.labelName}</span>
                                            <span>累计：{item.menuNumber}</span>
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {mealList.filter(fliterItem => dayMealList.map(item => item.foodId).indexOf(fliterItem.id as string) === -1)
                        .map((item, index) => {
                            return (
                                <div key={index} className="food-item" onClick={() => onFood(item, index)}>
                                    <div className="img">
                                        <img className="img-detail" src={getBaseImgLookUrl(item.image as string)} alt={item.name} />
                                        {/* <Checkbox className="img-check" checked={dayMealList.indexOf(item.id as number) !== -1 ? true : false} /> */}
                                        <Checkbox className="img-check" checked={false} />

                                    </div>
                                    <div className="message">
                                        <span className="name">{item.name}</span>
                                        <p className="other">
                                            <span>口感：{item.labelName}</span>
                                            <span>累计：{item.orderNum}</span>
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </YhBox>
        </div>
    )
}